/**
 * Keep Klaviyo Back In Stock on the PDP buy box only.
 *
 * Horizon renders full shopify-product-form markup inside cart-drawer Quick Add
 * (header, earlier in the DOM than MainContent). Klaviyo App Embed auto-binds
 * the first matching sold-out ATC pattern, so the waitlist button lands in the
 * drawer instead of the PDP. This script:
 *  1. Relocates a misplaced #klaviyo-bis-button-container into [data-kv-bis-slot]
 *  2. Syncs slot visibility with variant availability
 *  3. Leaves add-to-cart behaviour untouched
 */
(function () {
  const BIS_CONTAINER_ID = 'klaviyo-bis-button-container';
  const IGNORE_SELECTOR = '[data-kv-bis-ignore], quick-add-component, #csk-cart-drawer, .quick-add';
  const SLOT_SELECTOR = '[data-kv-bis-slot]';
  const PDP_FORM_SELECTOR = '[data-kv-pdp-product-form], [data-kv-pdp-buy-buttons]';

  function getSlot() {
    return document.querySelector(SLOT_SELECTOR);
  }

  function isIgnoredContext(node) {
    return Boolean(node && node.closest && node.closest(IGNORE_SELECTOR));
  }

  function isPdpContext(node) {
    return Boolean(node && node.closest && node.closest(PDP_FORM_SELECTOR));
  }

  function syncSoldOutUi(isSoldOut) {
    const slot = getSlot();
    if (!slot) return;

    if (isSoldOut) {
      slot.hidden = false;
      slot.removeAttribute('hidden');
    } else {
      slot.hidden = true;
      slot.setAttribute('hidden', '');
    }

    document.documentElement.classList.toggle('kv-bis-sold-out', Boolean(isSoldOut));
  }

  function relocateBisContainer() {
    const container = document.getElementById(BIS_CONTAINER_ID);
    const slot = getSlot();
    if (!container || !slot) return false;

    if (slot.contains(container) || isPdpContext(container)) {
      syncSoldOutUi(true);
      return false;
    }

    if (isIgnoredContext(container) || !isPdpContext(container)) {
      slot.appendChild(container);
      syncSoldOutUi(true);
      return true;
    }

    return false;
  }

  function onVariantUpdate(event) {
    const resource = event?.detail?.resource;
    if (!resource || resource.available == null) return;

    // Only react for the main PDP product form, not Quick Add cards.
    const sourceId = event?.detail?.sourceId;
    if (sourceId) {
      const sourceEl = document.getElementById(sourceId) || document.querySelector(`[id="${sourceId}"]`);
      if (sourceEl && isIgnoredContext(sourceEl)) return;
    }

    const productId = event?.detail?.data?.productId;
    const slot = getSlot();
    if (productId && slot?.dataset?.productId && String(productId) !== String(slot.dataset.productId)) {
      return;
    }

    const soldOut = resource.available === false;
    syncSoldOutUi(soldOut);

    if (slot && resource.id) {
      slot.dataset.variantId = String(resource.id);
      const trigger = slot.querySelector('.kv-bis-trigger, .klaviyo-bis-trigger');
      if (trigger) trigger.setAttribute('data-variant-id', String(resource.id));
    }

    if (soldOut) {
      // Klaviyo may have attached to Quick Add before the variant settled.
      relocateBisContainer();
    }
  }

  function init() {
    const slot = getSlot();
    if (slot && !slot.hasAttribute('hidden')) {
      document.documentElement.classList.add('kv-bis-sold-out');
    }

    relocateBisContainer();

    const observer = new MutationObserver(() => {
      relocateBisContainer();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    document.addEventListener('variant:update', onVariantUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
